const Forward = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 5.99992H5C3.34315 5.99992 2 7.34306 2 8.99992C2 10.6568 3.34315 11.9999 5 11.9999H8M14 5.99992L11.3333 3.33325M14 5.99992L11.3333 8.66659"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Forward;
